import { useState } from 'react'
import { Link } from 'react-router-dom'
import { tenantAPI } from '../services/api'
import { errorText } from '../utils/errorText'

export default function ForgotPassword() {
  const [email, setEmail] = useState('')
  const [sent, setSent] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [isLoading, setIsLoading] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError(null)
    setIsLoading(true)
    try {
      await tenantAPI.post('/auth/forgot-password', { email })
      setSent(true)
    } catch (err: any) {
      setError(errorText(err, 'Something went wrong. Please try again.'))
    } finally {
      setIsLoading(false)
    }
  }

  if (sent) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-theme-secondary">
        <div className="max-w-md w-full bg-theme-card rounded-lg shadow-lg p-8 border border-theme-border-primary">
          <div className="flex items-center justify-center space-x-3 mb-6">
            <img src="/aac.png" alt="Agentic Packr" className="w-10 h-10 object-contain" />
            <h2 className="text-2xl font-bold text-theme-text-primary">Check Your Email</h2>
          </div>
          <p className="text-theme-text-secondary text-center mb-4">
            If an account with <strong>{email}</strong> exists, we've sent a password reset link. Check your inbox.
          </p>
          <p className="text-sm text-theme-text-secondary text-center mb-6">
            The link expires in 24 hours.
          </p>
          <Link to="/login" className="block w-full text-center py-2 px-4 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors">
            Back to Sign In
          </Link>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-theme-secondary">
      <div className="max-w-md w-full bg-theme-card rounded-lg shadow-lg p-8 border border-theme-border-primary">
        <div className="flex items-center justify-center space-x-3 mb-6">
          <img src="/aac.png" alt="Agentic Packr" className="w-10 h-10 object-contain" />
          <h2 className="text-2xl font-bold text-theme-text-primary">Reset Password</h2>
        </div>
        <p className="text-theme-text-secondary text-center mb-6">
          Enter your email address and we'll send you a link to reset your password.
        </p>

        {error && (
          <div className="mb-4 p-3 bg-red-100 dark:bg-red-900/30 border border-red-300 dark:border-red-700 rounded-md">
            <p className="text-sm text-red-700 dark:text-red-400">{error}</p>
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-theme-text-secondary mb-1">Email</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-1 block w-full rounded-md bg-theme-input border border-theme-border-primary text-theme-text-primary px-3 py-2 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 focus:outline-none"
              placeholder="Enter your email"
            />
          </div>
          <button
            type="submit"
            disabled={isLoading}
            className="w-full py-2 px-4 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          >
            {isLoading ? 'Sending...' : 'Send Reset Link'}
          </button>
        </form>
        <div className="mt-4 text-center">
          <Link to="/login" className="text-sm text-blue-500 hover:text-blue-400">
            Back to Sign In
          </Link>
        </div>
      </div>
    </div>
  )
}
